/**
 * Where a member's profile lives, preferring the readable address.
 *
 *   /in/riccardovecchio      — the slug they chose, or one derived from
 *                              their name the first time anyone opened them
 *   /profileextern/<uuid>    — fallback, only for a member with no usable
 *                              name and no chosen address
 *
 * Pass whatever shape the payload came in as: list rows, the profile GET and
 * the public profile endpoint each nest these fields differently.
 */
export const profilePath = (source) => {
  if (!source) return null;

  const slug =
    source.profile_slug ??
    source.user?.profile_slug ??
    source.profile?.profile_slug ??
    null;
  if (slug && String(slug).trim()) {
    return `/in/${encodeURIComponent(String(slug).trim())}`;
  }

  const publicId =
    source.public_id ??
    source.user?.public_id ??
    source.profile?.public_id ??
    null;
  if (publicId && String(publicId).trim()) {
    return `/profileextern/${encodeURIComponent(String(publicId).trim())}`;
  }

  return null;
};

export default profilePath;
